export const PROVIDER_SORT_OPTIONS = {
  RECOMMENDED: "Recommended providers",
  NEAREST_TO_FURTHEST: "Distance",
  NAME_ASC: "Name (A-Z)",
  NAME_DESC: "Name (Z-A)",
} as const;

export const PROVIDER_SEARCH_SORT_VALUES = {
  NEAREST_TO_FARTHEST: "nearest_to_farthest",
} as const;

export type ProviderSearchSortBy =
  (typeof PROVIDER_SEARCH_SORT_VALUES)[keyof typeof PROVIDER_SEARCH_SORT_VALUES];
